import { ReactElement } from 'react'
import { PlayArrow } from '@mui/icons-material'
import { Box, Button, Stack, Typography } from '@mui/material'

interface Props {
  onStart: () => void
}

/**
 * Shown in the IFC Import drawer when the project has no IFC file yet and no mode is active: a short
 * hint and a button to start the guided import.
 */
const IFCImportStartInfo = ({ onStart }: Props): ReactElement => {
  return (
    <Box>
      <Stack spacing={2} alignItems="flex-start">
        <Typography variant="h6">IFC Import</Typography>
        <Typography variant="body2" color="text.secondary">
          Es ist noch keine IFC-Datei im Projekt vorhanden. Starten Sie den geführten Import, um
          eine IFC-Datei hochzuladen und zu konfigurieren.
        </Typography>
        <Button
          size="small"
          variant="contained"
          startIcon={<PlayArrow />}
          onClick={onStart}
          data-cy="btn-ifc-start-guided"
        >
          IFC Import starten
        </Button>
      </Stack>
    </Box>
  )
}

export default IFCImportStartInfo
